// Scoped to `.tl-review`. Values mirror tokens/colors.css + tokens/spacing.css in the
// "ThirdLine Reporting and Analytics" design system.
const REVIEW_STYLES = `
.tl-review {
  --navy-950: #0F1829; --navy-900: #14203A; --navy-800: #1E2E48; --navy-700: #2A3D5C;
  --navy-600: #3B5172; --navy-500: #50678C; --navy-400: #7286A6; --navy-300: #9DACC4;
  --navy-200: #C6D0DF; --navy-100: #E4EAF2; --navy-50: #F3F6FA;
  --gold-700: #C39A38; --gold-600: #D9AE4F; --gold-500: #E9C46A; --gold-200: #F9EBC8; --gold-100: #FCF5E4;
  --rust-700: #C2502F; --rust-600: #D85F40; --rust-500: #E77152; --rust-200: #F9D0C3; --rust-100: #FCEAE3;
  --air-200: #F2F7F9;
  --green-600: #2F7A63; --green-500: #3C9079; --green-100: #E2F0EB;
  --white: #FFFFFF;

  --surface-page: var(--navy-50);
  --surface-card: var(--white);
  --text-strong: var(--navy-800);
  --text-body: var(--navy-700);
  --text-muted: var(--navy-500);
  --text-subtle: var(--navy-400);
  --border-subtle: var(--navy-100);
  --border-default: var(--navy-200);

  --font-sans: 'Mulish', system-ui, -apple-system, 'Segoe UI', sans-serif;
  --font-display: 'Mulish', system-ui, -apple-system, sans-serif;
  --font-mono: 'IBM Plex Mono', ui-monospace, 'SF Mono', Menlo, monospace;
  --weight-semibold: 600;

  --text-2xs: 11px; --text-xs: 12px; --text-sm: 14px; --text-md: 16px;
  --text-lg: 18px; --text-xl: 20px; --text-2xl: 24px;

  --radius-xs: 4px; --radius-sm: 6px; --radius-md: 10px; --radius-lg: 14px;
  --radius-xl: 20px; --radius-pill: 999px;

  --shadow-md: 0 4px 12px rgba(30,46,72,.10), 0 2px 4px rgba(30,46,72,.06);
  --shadow-xl: 0 24px 56px rgba(30,46,72,.18);
  --ease-standard: cubic-bezier(.2, 0, 0, 1);

  font-family: var(--font-sans);
}

.tl-review__panel { animation: tl-review-in .22s var(--ease-standard); }
@keyframes tl-review-in { from { transform: translateY(10px) scale(.99) } to { transform: translateY(0) scale(1) } }

.tl-review__tab {
  background: none; border: none; cursor: pointer; padding: 10px 2px; margin-right: 24px;
  font-size: var(--text-sm); font-weight: 700; color: var(--text-muted);
  border-bottom: 2px solid transparent;
}
.tl-review__tab.is-active { color: var(--text-strong); border-bottom-color: var(--gold-500); }

.tl-review__ghost-btn {
  background: none; border: 1px solid var(--border-default); border-radius: var(--radius-sm);
  padding: 8px 14px; font-size: var(--text-sm); font-weight: 700; color: var(--text-body); cursor: pointer;
}
.tl-review__ghost-btn:hover { background: var(--navy-50); }

.tl-review__hint {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 7px 12px; border-radius: var(--radius-pill);
  background: var(--navy-50); border: 1px solid var(--border-default);
  font-size: var(--text-xs); font-weight: 700; color: var(--text-muted);
}

.tl-review__why .tooltip-inner { max-width: 360px; text-align: left; }

/* Bootstrap decision modals stack at 1050/1055, under this 1100 overlay. Unscoped on
   purpose: this <style> only exists while a review is open. */
.modal { --bs-modal-zindex: 1210; }
.modal-backdrop { --bs-backdrop-zindex: 1205; }
`

export default REVIEW_STYLES
